
import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Accordion, Button, Card } from "react-bootstrap";
import { searchCustomer, deleteCustomer } from "../store/api/CustomerApi";
import { Search } from "react-bootstrap-icons";
import { setDialog } from "../store/api/Modals";
import BihamtaTable from "../../Components/BihamtaTable";
const SearchCustomer = () => {
    const searchData = useRef({});
    const dispatch = useDispatch();
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-اطلاعات پایه";
    }, []);
    const search = () => {
        searchData.current.Skip = 0;
        searchData.current.Take = 10;
        dispatch(searchCustomer(searchData.current));
    }
    const history = useHistory();
    const showCustomer = (id) => {
        history.push("/BaseInfo/AddEditCustomer/" + id);
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "کد مشتری", colName: "Code", showInMobile: true },
        { colTitle: "کد اشتراک", colName: "SubscriptionCode", showInMobile: true },
        { colTitle: "مشخصات مشتری", colName: "Name", showInMobile: true },
        { colTitle: "تلفن", colName: "Phone", showInMobile: false },
        { colTitle: "همراه", colName: "Mobile", showInMobile: false },
        { colTitle: "استان", colName: "ProvinceName", showInMobile: false },
        { colTitle: "شهر", colName: "CityName", showInMobile: false },
        { colTitle: "آدرس", colName: "Address", showInMobile: false, colType:"string", maxTextLength:100 }
    ]
    const tableRowButtons = [
        {
            title: "حذف مشتری", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف مشتری',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteCustomer(item.ID, search)
                }))
            }
        },
        {
            title: "نمایش مشتری", type: "show", className: "group-Btn-smalll btn-success", onclick: (item) => showCustomer(item.ID)
        }

    ]
    return (<div className="container-fluid mt-1" style={{ minHeight: '80vh' }}>
        <br />
        <Card>
            <Card.Header className="headerStyle">جستجوی مشتریان</Card.Header>
            <Card.Body className="bodyStyle">
                <Accordion>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0" style={{ backgroundColor: "#12b5bd" }}>
                            فیلترهای جستجو
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <div className="row">
                                    <div className='form-group col-md-3'>
                                        <input placeholder='کد حساب' type='text' className='form-control' onChange={(e) => searchData.current.Code = e.target.value}></input>
                                    </div>
                                    <div className='form-group col-md-3'>
                                        <input placeholder='کد اشتراک ' type='text' className='form-control' onChange={(e) => searchData.current.SubscriptionCode = e.target.value}></input>
                                    </div>
                                    <div className="form-group col-md-3">
                                        <input type='text' placeholder='نام و نام خانوادگی' className="form-control" onChange={e => { searchData.current.Name = e.target.value }} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <input type='text' placeholder='تلفن' className="form-control" onChange={e => { searchData.current.Phone = e.target.value }} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <input type='text' placeholder='موبایل' className="form-control" onChange={e => { searchData.current.Mobile = e.target.value }} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <input type='text' placeholder='آدرس' className="form-control" onChange={e => { searchData.current.Address = e.target.value }} />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
                <div className="row">
                    <div>
                        <Button style={{ float: "right" }} className="mt-2 group-Btn" onClick={search}><Search size={15} />&nbsp;جستجوی مشتری</Button>
                    </div>
                </div>
                <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} searchMethod={(data) => dispatch(searchCustomer(data))} reducerName="customerDataReducer" objectName="customerList" hasPaging={true} filterData={searchData.current} />
            </Card.Body>

        </Card>
    </div>
    );
}
export default SearchCustomer;